import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ResponseModel } from '@app/shared/models/response.interface';
import { Load, LoadType } from '@app/shared/models/load.interface';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadService {
  private httpClient: HttpClient;
  constructor(private http: HttpClient, private handler: HttpBackend) {
    this.httpClient = new HttpClient(handler);
  }

  loadLookup(): Observable<ResponseModel<Load[]>> {
    return this.http.get<ResponseModel<Load[]>>(
      `${environment.API_URL}/loads/lookup`
    );
  }

  loadByType(id: number): Observable<ResponseModel<Load[]>> {
    return this.http.get<ResponseModel<Load[]>>(
      `${environment.API_URL}/loads/bytype/${id}`
    );
  }

  loadFind(identity: number): Observable<ResponseModel<Load>> {
    return this.http.get<ResponseModel<Load>>(
      `${environment.API_URL}/loads/${identity}`
    );
  }

  loadTypeFind(id: number): Observable<ResponseModel<LoadType>> {
    return this.http.get<ResponseModel<LoadType>>(
      `${environment.API_URL}/loadtypes/${id}`
    );
  }

  loadTypeFindByName(name: string): Observable<ResponseModel<LoadType>> {
    return this.http.get<ResponseModel<LoadType>>(
      `${environment.API_URL}/loadtypes/byname/${name}`
    );
  }

  loadCreate(load: Load): Observable<ResponseModel<Load>> {
    return this.http.post<ResponseModel<Load>>(
      `${environment.API_URL}/loads`,
      load
    );
  }

  loadUpdate(identity: number, load: Load): Observable<ResponseModel<Load>> {
    return this.http.put<ResponseModel<Load>>(
      `${environment.API_URL}/loads/${identity}`,
      load
    );
  }

  loadRemove(identity: number): Observable<ResponseModel<Boolean>> {
    return this.http.delete<ResponseModel<Boolean>>(
      `${environment.API_URL}/loads/${identity}`
    );
  }

  loadProcess(identity: number): Observable<ResponseModel<Boolean>> {
    return this.http.post<ResponseModel<Boolean>>(
      `${environment.API_URL}/loads/process/${identity}`,
      null
    );
  }

  loadCancel(identity: number): Observable<ResponseModel<Boolean>> {
    return this.http.post<ResponseModel<Boolean>>(
      `${environment.API_URL}/loads/cancel/${identity}`,
      null
    );
  }

  loadAttach(identity: number, file: any): Observable<ResponseModel<void>> {
    let formData: FormData = new FormData();
    formData.append('file', file, file.name);
    let token = localStorage.getItem('token');
    let reHeaders = new HttpHeaders({
      Authorization: `bearer ${token}`,
    });
    reHeaders.append('Content-Type', 'multipart/form-data');
    reHeaders.append('Accept', 'application/json');
    return this.httpClient.post<ResponseModel<void>>(
      `${environment.API_URL}/loads/upload/${identity}`,
      formData,
      { headers: reHeaders }
    );
  }

  loadDownload(identity: number): Observable<ResponseModel<Load>> {
    return this.http.get<ResponseModel<Load>>(
      `${environment.API_URL}/loads/download/${identity}`
    );
  }

  loadMetaData(loadId: number, type: string): Observable<ResponseModel<any>> {
    return this.http.get<ResponseModel<any>>(
      `${environment.API_URL}/loads/metadata/${loadId}/${type}`
    );
  }
}
